module.exports = __webpack_public_path__ + "img/hxfwbg.0c924cca.png";